<template>
    <div style="padding: 0 4.17vmin 4.17vmin 4.17vmin">
        <div style="width: 100%; position: relative">
            <!-- <div v-if="props?.noStudyData" style="text-align: center">
                <img src="/assets/images/symbols/target.png" />
                <p class="mapNoData30" style="padding: 50px 120px; text-align: center">아직 학습 기록이 없어요!</p>
            </div> -->
            <p v-if="props?.noStudyData" class="mapNoData30 learning--none">학습 기록이 없어요.<br />학습 홈으로 이동해서 학습을 시작하세요.</p>
            <template v-if="!isEmpty">
                <div v-if="!props?.noStudyData">
                    <!-- <div> -->
                    <div class="mg_top_16" style="width: 100%">
                        <div :style="'position: relative; left: calc(' + currentValue + '% - 49px);transition-property: left; transition-duration: 1s, 1s;'">
                            <p class="now">현위치</p>
                            <div class="marker">
                                <q-avatar>
                                    <img src="@/assets/images/icon/img_map_kreadbook02_green.png" />
                                </q-avatar>
                            </div>
                        </div>
                    </div>
                    <div style="width: 100%">
                        <div
                            class="pd_bottom_4"
                            :style="
                                'display: block; position: relative; left: calc(' +
                                startValue +
                                '% - 48px); max-width: 100px; text-align: center; font-size: 1.1vw; font-weight: 700; line-height: 1.4vw; transition-property: left; transition-duration: 1s, 1s'
                            "
                        >
                            출발점
                        </div>
                    </div>
                    <div style="width: calc(100%); position: absolute">
                        <div :style="'left: calc(' + currentValue + '% - 35px);position: relative; width: 70px; display: block;text-align: center; transition-property: left; transition-duration: 1s, 1s;'">
                            <img src="@/assets/images/icon/ico_map_polygon2.svg" style="width: 1.3vw" />
                        </div>
                    </div>
                    <div style="width: 100%">
                        <div :style="'left: calc(' + startValue + '% - 35px); position: relative;width: 70px;display: block;text-align: center;transition-property: left; transition-duration: 1s, 1s;'">
                            <img src="@/assets/images/icon/ico_map_polygon1.svg" style="width: 1.3vw" />
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="isEmpty">
                <p style="display: inline-flex; align-items: center; justify-content: center; margin-bottom: 0; font-size: 36px; width: 100%; text-align: center; height: 207px; color: #616161">
                    학습 기록이 없어요.<br />학습 홈으로 이동해서 학습을 시작하세요.
                </p>
            </template>
            <div style="margin: -3px 0 1.67vmin" class="data__graph">
                <q-linear-progress rounded size="16px" :value="((props.level - 1) * 96 + props.lesson) / (props.maxLevel * 96)" :color="isEmpty || props.noStudyData ? 'grey-6' : 'primary'" class="q-mt-sm" />
            </div>
            <div style="width: calc(100%); position: absolute" class="data__txt">
                <template v-for="i in props.maxLevel">
                    <div v-for="ii in 2" :style="'position: absolute; left: calc(' + (((i - 1) * 2 + (ii - 1)) / (props.maxLevel * 2)) * 100 + '% - 25px); max-width: 120px; font-size: 0.8vw; font-weight: 500; line-height: 1.1vw; text-align: center'">
                        {{ i }}레벨<span style="display: block; font-weight: inherit">{{ ii % 2 !== 0 ? '1레슨' : '48레슨' }}</span>
                    </div>
                </template>
                <div :style="'position: absolute; left: calc(100% - 25px); min-width: 120px; font-size: 0.8vw; font-weight: 500; line-height: 1.1vw; text-align: center;'">
                    {{ props.maxLevel }}레벨<span style="display: block; font-weight: inherit">96레슨</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';

const maxValue = ref(null);
const currentValue = ref(0);
const startValue = ref(0);
const isEmpty = ref(false);
const props = defineProps({
    noStudyData: {
        default: false,
    },
    startLesson: {
        default: 1,
    },
    startLevel: {
        default: 1,
    },
    lesson: {
        default: 1,
    },
    level: {
        default: 1,
    },
    maxLevel: {
        default: 3,
    },
    height: {
        default: 16,
    },
    color: {
        default: 'primary',
    },
    textColor: {
        default: '#8E8E8E',
    },
});

const max = 96;
onMounted(() => {
    maxValue.value = props.maxLevel * max;
    if (props.level === 0 && props.lesson === 0) {
        isEmpty.value = true;
    }
    setTimeout(() => {
        startValue.value = (((props.startLevel - 1) * max + props.startLesson) / (props.maxLevel * max)) * 100;
        currentValue.value = (((props.level - 1) * max + props.lesson) / (props.maxLevel * max)) * 100;
    }, 1000);
});
</script>

<style scoped lang="scss">
/* .marker {
    width: 98px;
    height: 120px;
    position: relative;
    background-image: url('@/assets/images/symbols/ellipse.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: center;
    font-weight: 700;
    // font-size: 2.2vmin;
    font-size: 24px;
    text-align: center;
    padding-top: 3px;
    color: white;
} */

::v-deep {
    .marker {
        width: 6.5vw;
        height: 6.5vw;
        // margin-bottom: 1.6vw;
        .q-avatar__content {
            width: 6.5vw;
            height: 6.5vw;
        }
    }
}

.rounded-borders {
    border-radius: 30px;
}
.now {
    display: inline-block;
    position: relative;
    padding: 0.5vmin 1.33vmin;
    margin-bottom: 0.6vw;
    margin-left: 1vmin;
    @include border-radius(3.33vmin);
    background: $color_primary;
    font-size: 1.1vw;
    font-weight: 700;
    color: $color_white;
    line-height: 1.4vw;
    &::after {
        content: '';
        position: absolute;
        bottom: -0.6vw;
        left: 50%;
        width: 1vw;
        height: 0.7vw;
        background: url('@/assets/images/symbols/Polygon.svg') no-repeat center / contain;
        @include transform(translateX(-50%));
    }
}

.learning--none {
    padding-top: 14.5vw;
    margin-bottom: 0;
    background: url('@/assets/images/icon/img_empty_archer.png') no-repeat top 2.5vw center/ 14vw;
    text-align: center;

    + .data__graph {
        display: none;

        + .data__txt {
            display: none;
        }
    }
}
</style>
